import { fetchSiteTraitsResource } from '@atlassian/jira-router-resources-recommendations/src/services/fetch-site-traits/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import type { ProjectType } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';

export type TraitData = {
	name: string;
	value: string | boolean | number;
} | null;

export const jiraTrait = 'jsw_ccp_auto_upgraded_trialing_and_predunning_sites';
export const jsmTrait = 'jsm_ccp_auto_upgraded_trialing_and_predunning_sites';
export const jpdTrait = 'jpd_ccp_auto_upgraded_trialing_and_predunning_sites';

const getProductSpecificTrait = (
	siteTraitsData: TraitData[] | null,
	productType: ProjectType | undefined,
) => {
	return siteTraitsData && productType
		? siteTraitsData.find((trait) => {
				if (!trait) return;

				switch (productType) {
					case 'software':
						return trait.name === jiraTrait;
					case 'service_desk':
						return trait.name === jsmTrait;
					case 'product_discovery':
						return trait.name === jpdTrait;
					default:
						return false;
				}
			})
		: undefined;
};

export const useAutoUpgradeTrait = ({ projectType }: { projectType: ProjectType | undefined }) => {
	const siteTraitsResource = resourceWithCondition2(
		() => !!projectType && fg('auto_upgrade_not_a_trial_gate'),
		fetchSiteTraitsResource,
	);

	const { data: siteTraitsData } = useResource<TraitData[]>(siteTraitsResource);

	const productTrait = getProductSpecificTrait(siteTraitsData, projectType);

	return {
		productTrait,
	};
};
